// extracted by mini-css-extract-plugin
export var postsGroup = "postsGroup-module--postsGroup--mnsUB";
export var title = "postsGroup-module--title--dc3mj";
export var threeItems = "postsGroup-module--threeItems--2v2gz";
export var lineSeparator = "postsGroup-module--lineSeparator--3TvxP";
export var lineSeparatorLabel = "postsGroup-module--lineSeparatorLabel--21MXn";
export var moduleHeadline = "postsGroup-module--moduleHeadline--1PJ9N";